import React from 'react';
import PropTypes from 'prop-types';
import { includes, isNull } from 'lodash';

const PlayerCheckbox = ({ responseType, answer} ) => {
  const checkBoxes = responseType.possibleAnswers.map ( (a, aIdx) => {
    const bActive =  !isNull(answer) && includes(answer.answerHandles, a.handle);
    const id = `rc-${responseType.id}-${aIdx}`;
    return (
      <fieldset key={id} className='o-checkbox-answer'>
        <input name={id} type="checkbox" checked={bActive} readOnly={true}/>
        <label htmlFor={id}>{a.label}</label>
      </fieldset>
    );
  })
  return (
    <div className='o-player-cell'>
      {checkBoxes}
    </div>
  );
}

PlayerCheckbox.propTypes = {
  responseType: PropTypes.object.isRequired,
  answer: PropTypes.object,
}

export default PlayerCheckbox;
